import { CustomErrorService } from './services/custom-error.service';
import { RouterModule } from '@angular/router';
import { StringService, ToastrService } from './services';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CookieService } from 'ng2-cookies';
import { ToasterModule } from 'angular2-toaster';

@NgModule({
    imports: [CommonModule, RouterModule],
    exports: [],
    declarations: [],
    providers: [StringService,      
                CookieService,  
                CustomErrorService,
                ToastrService]
})
export class CoreModule { }
